import React from 'react';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { themeLight } from '@naf/theme';
// Replace the values in defaultTheme with the same keys in the theme being passed
export const ThemeProvider = ({
  children,
  theme = {}
}) => {
  return /*#__PURE__*/React.createElement(StyledProvider, {
    theme: {
      ...themeLight,
      ...theme
    }
  }, children);
};
export default ThemeProvider;
//# sourceMappingURL=theme-provider.js.map